module.exports = __webpack_public_path__ + "img/arrows.837b7f57.png";